import TimeAgo from "react-timeago";

import { SyncAlert } from "./SyncAlert";

export const SyncTime: React.FC<{ lastUpdated: Date | null | undefined }> = ({ lastUpdated }) => {
  return (
    <>
      <SyncAlert lastUpdated={lastUpdated} />{" "}
      {lastUpdated ?
        <TimeAgo date={lastUpdated} />
      : <>never synced</>}
    </>
  );
};
